import React from 'react';

interface ModalProps {
    show: boolean;
    children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ show, children }) => {
    return (
        <div
            className={`${
                show ? 'fixed' : 'hidden'
            } z-[100] flex justify-center items-center top-0 left-0 w-full h-full`}
        >
            <div className='absolute bg-black opacity-50 top-0 left-0 w-full h-full'></div>
            <div className='bg-white rounded-xl shadow-lg p-6 z-20'>{children}</div>
        </div>
    );
};

export default Modal;
